<script setup lang="ts">
import type { NovaBoxPremiumCreatorsItemProps } from './NovaBoxPremiumCreatorsItem.types'

withDefaults(defineProps<NovaBoxPremiumCreatorsItemProps>(), {
  on: false,
  loading: false,
})
</script>

<template>
  <div :class="['my-premium-item', { on, loading }]">
    <div class="portrait-box">
      <NovaPortraitContainer :image-url="source.crtrProfileUrl" :size="'sm'" />
      <span v-if="source.newPostAt === 'Y'" class="new-mark">New</span>
    </div>

    <span class="user-name">{{ source.crtrUserNcnm }}</span>

    <NovaLoadingIndicator
      v-if="loading"
      :bg-bright="'light'"
      class="loading-indicator"
    />
  </div>
</template>

<style lang="scss" scoped>
.my-premium-item {
  position: relative;
  flex-shrink: 0;
  display: flex;
  padding: 5px;
  justify-content: flex-start;
  align-items: center;
  gap: 5px;
  cursor: pointer;
  border-radius: 6px;
  overflow: hidden;
  @include transition(background-color 0.2s ease-in-out);

  &.on {
    background-color: #b0d4ff;
  }

  &.loading {
    pointer-events: none;
  }

  @media (hover: hover) {
    &:hover {
      background-color: $color-bg-custom-2;
    }
  }

  &:active {
    background-color: $color-bg-custom-3;
  }

  .portrait-box {
    position: relative;

    .new-mark {
      display: block;
      position: absolute;
      bottom: 0;
      right: 0;
      width: 10px;
      height: 10px;
      border-radius: 5px;
      background-color: $color-primary-red;
      border: 1px solid $color-bg-3;
      text-indent: -9999em;
    }
  }

  .user-name {
    @include text-style($text-body-14-regular);
    @include ellipsis(1);
  }

  .loading-indicator {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  @include mobile {
    flex: none;
    flex-direction: column;
    width: 64px;
    border-radius: 0;

    .user-name {
      @include text-style($text-body-10-regular);
    }
  }
}
</style>
